import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_tile-right-click';
/**
 * Fired when user right clicks anywhere on a product tile (limited to Search and CatNav for now)
 */
export function trackProductTileRightClick(context_string, requestId_string2, productToken, promotedBy_string3, impressionId_string4) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            context_string,
            requestId_string2,
            productToken,
            promotedBy_string3,
            impressionId_string4,
        },
    });
}
